module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hero', {
    attrs: {
      "content": _vm.heroContent
    },
    on: {
      "hamburger": _vm.hamburgerClicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('voters', {
    staticClass: "voters col-xs-12"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix topper"
  }, [_c('critic-quote', {
    staticClass: "col-xs-12 no-pad",
    attrs: {
      "id": "bestProductionSlider1",
      "criticSliderContent": _vm.criticSlider1
    }
  }), _vm._v(" "), _vm._m(0, false, false)], 1), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('production-quote', {
    staticClass: "col-xs-12",
    attrs: {
      "id": "bestProductionQuote1",
      "prodQuote": _vm.prodQuoteContent1
    }
  })], 1), _vm._v(" "), _c('slider-image', {
    attrs: {
      "sliderContent": _vm.imageSlider2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix grid"
  }, [_c('production-quote', {
    staticClass: "col-xs-12 col-md-6",
    attrs: {
      "id": "bestProductionQuote2",
      "prodQuote": _vm.prodQuoteContent2
    }
  }), _vm._v(" "), _vm._m(2, false, false)], 1), _vm._v(" "), _c('click-thru', {
    attrs: {
      "clickThru": _vm.clickThru
    },
    on: {
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('social'), _vm._v(" "), _c('legal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-10 col-md-offset-1 video no-pad hideme",
    attrs: {
      "id": "video-pad"
    }
  }, [_c('video', {
    staticClass: "video-js vjs-default-skin",
    attrs: {
      "controls": "",
      "preload": "none",
      "data-setup": "{\"fluid\": true}",
      "poster": require("../../assets/video/best_production_design_video_01.jpg")
    }
  }, [_c('source', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/video/upload/v1627708418/fsl/video/best_production_design_video_01.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/video/upload/v1627708418/fsl/video/best_production_design_video_01.webm",
      "type": "video/webm"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix grid"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 image hideme"
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/best_production_block_1.jpg",
      "alt": "The Shape of Water"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 image hideme"
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/best_production_block_2.jpg",
      "alt": "The Shape of Water"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 image hideme"
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/best_production_block_3.jpg",
      "alt": "The Shape of Water"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 image hideme"
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/best_production_block_4.jpg",
      "alt": "The Shape of Water"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 image hideme"
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/best_production_block_5.jpg",
      "alt": "The Shape of Water"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 image hideme"
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/best_production_block_6.jpg",
      "alt": "The Shape of Water"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 image hideme"
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/best_production_block_7.jpg",
      "alt": "The Shape of Water"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 image hideme"
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/best_production_block_8.jpg",
      "alt": "The Shape of Water"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 image hideme"
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/office.jpg",
      "alt": "The Shape of Water"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-511ec320", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-511ec320","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/categoryPages/BestProduction.vue
// module id = 407
// module chunks = 0